/*
 * @Author: your name
 * @Date: 2021-09-09 10:23:29 婚姻取名
 * @LastEditTime: 2021-09-09 13:50:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \taotan_admin\src\router\modules\MarriageGetName.js
 */
const marriageGetName=[
  {
    path: "babyMame",
    name: "BABY_NAME",
    meta: {
      title: "国学",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/marriageGetName/babyName"),
  },
  {
    path: "babyMameDesSet",
    name: "BABY_NAME_DES_SET",
    meta: {
      title: "说明设置",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/marriageGetName/babyName/babyMameDesSet"),
  },
  {
    path: "babyMameStyleSet",
    name: "BABY_NAME_STYLE_SET",
    meta: {
      title: "样式设置",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/marriageGetName/babyName/babyMameStyleSet"),
  },
  {
    path: "sinologyStyle",
    name: "SINOLOGY_STYLE",
    meta: {
      title: "国学样式",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/marriageGetName/sinologyStyle"),
  },
  {
    path: "sinologyNav",
    name: "SINOLOGY_NAV",
    meta: {
      title: "国学导航",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/marriageGetName/sinologyNav"),
  },
  

]
export default marriageGetName